import { isWeb } from "@memorang/helpers/platform";
import Icon from "@react-native-vector-icons/material-design-icons/static";
import { Chip, type ChipProps, Text, type TextProps } from "react-native-paper";
import type { IconType } from "../../icon";

type Props = {
	children: React.ReactNode;
	textStyle?: object;
	iconColor?: string;
	textVariant?: TextProps<typeof Text>["variant"];
	hasTooltip?: boolean;
	numberOfLines?: number;
} & ChipProps;

const CustomChip = ({
	children,
	icon,
	textStyle = {},
	iconColor,
	textVariant = "labelSmall",
	hasTooltip = false,
	numberOfLines,
	...rest
}: Props) => {
	const BaseComponent = () => (
		<Chip
			compact
			{...rest}
			icon={(props) =>
				icon ? (
					<Icon name={icon as IconType} {...props} color={iconColor} />
				) : null
			}
		>
			<Text
				style={{
					...textStyle,
				}}
				variant={textVariant}
				numberOfLines={numberOfLines}
			>
				{children}
			</Text>
		</Chip>
	);
	return isWeb && hasTooltip ? (
		<div
			style={{
				position: "relative",
				display: "inline-flex",
				alignItems: "center",
			}}
		>
			<div
				style={{
					position: "absolute",
					inset: 0,
					cursor: "help",
					zIndex: 1,
				}}
			/>
			<BaseComponent />
		</div>
	) : (
		<BaseComponent />
	);
};

export default CustomChip;
